import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { workOrder, workOrderCategory } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { downloadExcel } from "../../utils/exporter";
import moment from "moment";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  getRequestStatusColor,
  getStatusColor,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import Calendar from "../calendar/calendar.js";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { format } from "date-fns";
import WorkOrderKanbanBoard from "./work-order-kanban.js";
import RequestKanbanBoard from "./request-kanban.js";
import CalendarWorkOrder from "./calendar.js";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";
import DebounceInput from "../../components/form/HorizontalDebounceInput/index.jsx";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useSearchParams } from "react-router-dom";

function WorkOrderList({ isRequest = false }) {
  const [datas, setDatas] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const q = {
    page: searchParams.get("page") ? parseInt(searchParams.get("page")) : 1,
    take: searchParams.get("take") ? parseInt(searchParams.get("take")) : 10,
    keyword: searchParams.get("keyword") || "",
    status: searchParams.get("status") || "",
    category_id: searchParams.get("category_id") || "",
    location_id: searchParams.get("location_id") || "",
    startDate: searchParams.get("startDate") || null,
    endDate: searchParams.get("endDate") || null,
  }

  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState(()=>({ ...q}));
  const [totalData, setTotalData] = useState(0);
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const navigate = useNavigate();
  const [viewType, setViewType] = useState(searchParams.get("viewType") || "list");
  const [openPublic, setOpenPublic] = useState(false);
  const [categories, setCategories] = useState([]);
  const [statuses, setStatuses] = useState(isRequest
    ? ["Pending", "Approved", "Declined"]
    : ["Open", "In Progress", "On Hold", "Completed"]);
  const [publicToken, setPublicToken] = useState("");
  const [openCustomToken, setOpenCustomToken] = useState(false);
  const [newToken, setNewToken] = useState("");
  const [host, setHost] = useState("");

  async function getData() {
    try {
      const token = await workOrder.getPublicToken();
      if (token.ok) {
        const body = await token.json();
        setPublicToken(body.data);
        setNewToken(body.data);
      }
      setLoading(true);
      const queryParam = {
        ...query,
        isRequest,
      };

      if (!queryParam.startDate) {
        delete queryParam.startDate;
        delete queryParam.endDate;
      }

      if (viewType == "calendar") {
        delete queryParam.page;
        delete queryParam.take;
      }
      if (viewType == "column") {
        delete queryParam.page;
        delete queryParam.take;
      }

      const res = await workOrder.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          data.results.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setDatas(data.results);
          setTotalData(data.totalData);
        }

      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    if (viewType !== "calendar") {
      getData();

    }

    const queryParam = {
      ...query,
    };

    if (!queryParam.startDate) {
      delete queryParam.startDate;
      delete queryParam.endDate;
    }
    if (viewType == "calendar") {
      delete queryParam.page;
      delete queryParam.take;
    }
    setSearchParams({
      ...queryParam,
      viewType: viewType,
    });

    // eslint-disable-next-line
  }, [query.page, query.take, query.location_id, query.category_id, viewType, query.keyword,query.status,query.startDate,query.endDate]);

  const downloadExcelHandler = async () => {
    downloadExcel(datas, "WorkOrder");
  };

  const getCategory = async () => {
    const res = await workOrderCategory.list();
    if (res.ok) {
      const body = await res.json();
      setCategories(body.data);
    }
  };

  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">More detail</div>
              <div className="col-md-9">
                <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                      <label>Title</label>
                      <p>{data.title}</p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Asset</label>
                      <p>{data.asset?.asset_name}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Category</label>
                      <p>{data.category?.name}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Priority</label>
                      <p>{data.priority}</p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted By</label>
                      <p>{data.created_by_user?.firstname || data.requested_by}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted At</label>
                      <p>
                        {format(new Date(data.created_at), "yyyy-MM-dd hh:mm")}
                      </p>
                    </div>
                  </div>

                  {isRequest && data.request_status !== "Pending" && (
                    <>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>{data.request_status} by</label>
                          <p>{data.action_taken_by_user?.firstname}</p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>{data.request_status} at</label>
                          <p>
                            {format(
                              new Date(data.action_taken_date),
                              "yyyy-MM-dd hh:mm"
                            )}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    !isRequest
                      ? navigate("/work-order/detail/" + data.id)
                      : navigate("/request/detail/" + data.id)
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>

                {isRequest && data.request_status == "Approved" && (
                  <button
                    style={{ marginRight: "10px" }}
                    onClick={() => navigate("/work-order/detail/" + data.id)}
                    type="button"
                    className="btn btn-outline-primary"
                  >
                    View Work Order
                  </button>
                )}

                {!isRequest && (
                  <>
                    <button
                      onClick={() => navigate("/work-order/edit/" + data.id)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-warning"
                    >
                      <i className="fa fa-edit"></i> Edit{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>

                    <PermissionChecker permissions={["delete work order"]} hideIfNotAllowed>
                    <button
                      onClick={() => showConfirmationDlg(data)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-danger"
                    >
                      <i className="fa fa-edit"></i> Delete{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>
                    </PermissionChecker>
                  </>
                )}

                {isRequest && data.request_status == "Pending" && (
                  <>
                    <button
                      onClick={() => navigate("/request/edit/" + data.id)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-warning"
                    >
                      <i className="fa fa-edit"></i> Edit{" "}
                      {isRequest ? "Request" : "Work Order"}
                    </button>

                    <PermissionChecker permissions={["delete request"]} hideIfNotAllowed>
                    <button
                      onClick={() => showConfirmationDlg(data)}
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn btn-outline-danger"
                    >
                      <i className="fa fa-trash"></i> Delete{" "}
                      {isRequest ? "Request" : "Work Order"}
                      </button>
                      </PermissionChecker>
                  </>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  async function deleteData() {
    try {
      const response = await workOrder.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success(
            `This ${
              deleteRow.is_request ? "request" : "work order"
            } has been deleted`
          );

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  let columns = [

    {
      name: "No",
      selector: (row) => row.number,
      minWidth: "30px",
    },
    {
      name: "Customer",
      selector: (row) => row.location?.location_name,
      minWidth: "230px",
      cell: (row) =>{
        const locationNameArr = [];
        generateLocationToArray(row.location, locationNameArr);

        return locationNameArr[locationNameArr.length - 1];
      }

    },

    {
      name: "Title",
      selector: (row) => row.title,
      minWidth: "150px",
    },

    {
      name: "Category",
      selector: (row) => row.category?.name,
    },
    ...generateLocationWording().map((w, i) => ({
      name: w,
      grow: 1,
      wrap: true,
      minWidth: "220px",
      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Asset",
      selector: (row) => row.asset?.asset_name,
    },

    {
      name: "Priority",
      selector: (row) => row.priority,
      cell: (row) => (
        <span
          className={`badge border ${
            row.priority === "high"
              ? "border-danger text-danger"
              : row.priority === "medium"
              ? "border-warning text-warning"
              : "border-success text-success"
          }`}
          style={{ textTransform: "capitalize" }}
        >
          {row.priority}
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge border border-${getStatusColor(
            row.status
          )} text-${getStatusColor(row.status)}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
      cell: (row) => formatDateOnly(row.start_date),
    },
    {
      name: "Due Date",
      selector: (row) => row.due_date,
      cell: (row) => formatDateOnly(row.due_date),
    },
    {
      name: "Submitted By",
      selector: (row) => row.created_by_user?.firstname || row.requested_by,
    },
    {
      name: "Submitted At",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
  ];

  if (isRequest) {
    columns = columns.filter(
      (c) => !["Priority", "Start Date", "Due Date"].includes(c.name)
    );
    columns.splice(3, 0, {
      name: "Request Status",
      selector: (row) => row.request_status,
      cell: (row) => (
        <span
          className={`badge border border-${getRequestStatusColor(
            row.request_status
          )} text-${getRequestStatusColor(row.request_status)}`}
        >
          {row.request_status}
        </span>
      ),
    });

    columns.push({
      name: "Approved by",
      selector: (row) =>
        row.request_status == "Approved"
          ? row.action_taken_by_user?.firstname
          : "-",
    });
    columns.push({
      name: "Approved at",
      selector: (row) =>
        row.request_status == "Approved"
          ? formatDateOnly(row.action_taken_date)
          : "-",
    });

    columns.push({
      name: "Declined by",
      selector: (row) =>
        row.request_status == "Declined"
          ? row.action_taken_by_user?.firstname
          : "-",
    });
    columns.push({
      name: "Declined at",
      selector: (row) =>
        row.request_status == "Declined"
          ? formatDateOnly(row.action_taken_date)
          : "-",
    });
  }

  const handleChangeLocationFilter = (location) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      location_id: location ? location.id : "",
    }));
  };

  const handleChangeCategory = (id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      category_id: id,
    }));
  };

  const handleChangeKeyword = (e) => {
    setQuery((prev) => ({
      ...prev,
      keyword: e.target.value,
      page: 1,
    }));
  };

  const handleChangeStatus = (id) => {
    setQuery((prev) => ({
      ...prev,
      status: id,
      page: 1,
    }));
  };

  const handleDateRangeApplyEvent = (event, picker) => {
    const startDate = picker.startDate;
    const endDate = picker.endDate;
    setQuery((prev) => ({
      ...prev,
      startDate: startDate.startOf("day"),
      endDate: endDate.endOf("day"),
      page: 1,
    }));
  };

  const handleDateRangeCancelEvent = () => {
    setQuery((prev) => ({
      ...prev,
      startDate: null,
      endDate: null,
      page: 1,
    }));
  };


  // useEffect(() => {
  //   getData();
  //   setViewType("list");
  //   // eslint-disable-next-line
  // }, [isRequest]);

  useEffect(() => {
    getCategory();
    const origin = window.location.origin;
    setHost(origin);
  }, []);

  const copyClipboard = () => {
    const host = window.location.origin;
    navigator.clipboard.writeText(`${host}/public-request/${publicToken}`);
    toast.success("Link Copied to clipboard");
  };

  const submitNewToken = async () => {
    try {
      const res = await workOrder.setNewPublicToken(newToken);
      if (res.ok) {
        const body = await res.json();
        setPublicToken(body.data);
        toast.success("New token update successfully");

        setOpenCustomToken(false);
      } else {
        const body = await res.json();
        toast.error(body.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      getData();
    }
  };

  return (
    <div >
      <ConfirmationDlg
        title={"Create Custom URL"}
        open={openCustomToken}
        btnSubmitText={"Update"}
        btnCancelText={"Cancel"}
        onClose={() => setOpenCustomToken(false)}
        onSubmit={submitNewToken}
      >
        <p>{host}/public-request/</p>
        <input
          type="text"
          onChange={(e) => setNewToken(e.target.value)}
          value={newToken}
          className={"form-control border border-1 border-theme"}
        />
        <div className="alert alert-info justify-content-between mt-2">
          Your new token will be:
          <hr />
          <small>
            {host}/public-request/{newToken}
          </small>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        title={"Public URL"}
        open={openPublic}
        onClose={() => setOpenPublic(false)}
        onSubmit={() => setOpenPublic(false)}
      >
        <p>This is the public URL to create a Request :</p>
        <div class="alert alert-info d-flex justify-content-between">
          <div>
            {host}/public-request/{publicToken}
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button className="btn btn-info" onClick={copyClipboard}>
            <i className="fa fa-copy"></i> Copy Link
          </button>

          <button
            className="btn btn-primary"
            onClick={() => {
              setOpenCustomToken(true);
              setOpenPublic(false);
              setNewToken(publicToken);
            }}
          >
            <i className="fa fa-edit"></i> Create Custom URL Link
          </button>
        </div>
      </ConfirmationDlg>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">{isRequest ? "REQUEST" : "WORK ORDER"}</a>
            </li>
            <li className="breadcrumb-item active"> LIST</li>
          </ul>

          <h1 className="page-header">
            {isRequest ? "Request" : "Work Order"} List
          </h1>


          <div class="col-sm-2 d-flex justify-content-between">
                <div
                  className="  mb-2 mb-sm-0 btn-group"
                  role="group"
                  aria-label="Basic example"
                  style={{ marginRight: 10 }}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>List View</Tooltip>}
                  >
                    <button
                      onClick={() => setViewType("list")}
                      type="button"
                      className={`btn ${
                        viewType == "list" ? "btn-theme" : "btn-outline-theme"
                      }`}
                    >
                      <i className="bi bi-list"></i>
                    </button>
                  </OverlayTrigger>

                  {!isRequest && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Calendar View</Tooltip>}
                    >
                      <button
                        onClick={() => setViewType("calendar")}
                        type="button"
                        className={`btn ${
                          viewType == "calendar"
                            ? "btn-theme"
                            : "btn-outline-theme"
                        }`}
                      >
                        <i className="bi bi-calendar"></i>
                      </button>
                    </OverlayTrigger>
                  )}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Column View</Tooltip>}
                  >
                    <button
                      onClick={() => setViewType("column")}
                      type="button"
                      className={`btn ${
                        viewType == "column" ? "btn-theme" : "btn-outline-theme"
                      }`}
                    >
                      <i className="bi bi-kanban"></i>
                    </button>
                  </OverlayTrigger>
                </div>

              </div>

          <hr className="mb-3" />

          <div className="mb-5">



             <div className="row mb-2 justify-content-sm-end">


              <div className="col-sm-2 mb-2 mb-sm-0">
                <DebounceInput value={query.keyword} name="keyword" placeholder={`Search ${isRequest ? "Request" : "Work Order"}..`} showDebounceIndicator delay={1000} onchange={handleChangeKeyword} />
              </div>




              <div className="col-sm-2 mb-2 mb-sm-0">
                <LocationFilter selectedId={query.location_id} onChange={handleChangeLocationFilter} />
              </div>
              <div className="col-sm-2 mb-2 mb-sm-0">
                <select
                  value={query.category_id}
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeCategory(e.target.value);
                  }}
                >
                  <option value="">
                    - Category -
                  </option>
                  {categories.map((c, i) => (
                    <option value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>

              <div className="col-sm-2 mb-2 mb-sm-0">
                <select
                  value={query.status}
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeStatus(e.target.value);
                  }}
                >
                  <option value="">
                    - Status -
                  </option>
                  {statuses.map((c, i) => (
                    <option value={c}>{c}</option>
                  ))}
                </select>
              </div>

              {viewType !== "calendar" && <div className="col-sm-2 mb-2 mb-sm-0">
                <DateRangePicker
                  {...(query.startDate && query.endDate ? {
                    initialSettings: {
                      startDate: moment(query.startDate).format("MM/DD/YYYY"),
                      endDate: moment(query.endDate).format("MM/DD/YYYY"),
                    },
                  } : {})}
                  onApply={handleDateRangeApplyEvent}
                  onCancel={handleDateRangeCancelEvent}
                >
                  <button
                    className="btn btn-outline-theme text-truncate me-3 mb-2 mb-sm-0 text-left "
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    <i className="fa fa-fw fa-calendar me-1"></i>
                    <span>{query.startDate ? formatDateOnly(query.startDate) + " - " + formatDateOnly(query.endDate) : "Select Date Range"}</span>
                    <i className="fa fa-fw fa-caret-down me-n1"></i>
                  </button>
                </DateRangePicker>

              </div>
              }


              <div className="col-sm-2 mb-2 mb-sm-0">
                <div class="row">
                  <div class={isRequest ? "col-sm-12" : "col-sm-12"}>
                    <button
                      onClick={() => {
                        !isRequest
                          ? navigate("/work-order/add")
                          : navigate("/request/add");
                      }}
                      className="btn btn-outline-theme w-100"
                    >
                      <i className="bi bi-plus"></i>
                      Add {isRequest ? "Request" : "Work Order"}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>


            {viewType == "list" && (
              <div className="row">
                <div className="col-md-12">
                  <Card>
                    <CardBody>
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        highlightOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        paginationDefaultPage={query.page}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row) =>
                          setQuery((prev) => ({ ...prev, page: 1, take: row }))
                        }
                        paginationPerPage={query.take}
                        paginationTotalRows={totalData}
                        onChangePage={(page) =>
                          setQuery((prev) => ({ ...prev, page: page }))
                        }
                      />

                    </CardBody>
                  </Card>
                </div>
              </div>
            )}

            {viewType == "calendar" && <CalendarWorkOrder query={query} />}

            {viewType == "column" && !isRequest && (
              <WorkOrderKanbanBoard
              query={query}
              datas={datas}
              onChangeRowsPerPage={(row) =>
              setQuery((prev) => ({ ...prev, page: 1, take: row }))
            }
            paginationTotalRows={totalData}
            onChangePage={(page) =>
              setQuery((prev) => ({ ...prev, page: page }))
            }
            />
            )}
            {viewType == "column" && isRequest && (
            <RequestKanbanBoard
            query={query}
            datas={datas}
            onChangeRowsPerPage={(row) =>
            setQuery((prev) => ({ ...prev, page: 1, take: row }))
          }
          paginationTotalRows={totalData}
          onChangePage={(page) =>
            setQuery((prev) => ({ ...prev, page: page }))
          }

            />
            )}
          </div>




        </div>
      </div>




      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Work Order"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this work order{" "}
            <strong>{deleteRow.title}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default WorkOrderList;
